/// <amd-module name="Agile/Common/Redux/TeamSettings/TeamSettingsActions" />
import { ITeamSettings } from "Agile/Contracts/Common";
import { ActionWithPayload, createAction } from "redux/Utils/ActionHelper";

export interface ITeamSettingsLoadedAction extends ActionWithPayload<TeamSettingsActionTypes.TeamSettingsLoadedAction, ITeamSettings> {}

export const TeamSettingsActionsCreator = {
    teamSettingsLoaded: (data: ITeamSettings): ITeamSettingsLoadedAction => createAction(TeamSettingsActionTypes.TeamSettingsLoadedAction, data)
};

export const enum TeamSettingsActionTypes {
    TeamSettingsLoadedAction = "TeamSettingsLoaded"
}

export type TeamSettingsAction = ITeamSettingsLoadedAction;
